import { createFormDataRequest } from "@/helpers/FormHelpers";
import CompanyCourseInstructor, {
  CompanyCourseInstructorFormSend,
} from "@/interfaces/CompanyCourseInstructor";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import api from "@/services/api";

export const companyCourseInstructorsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyCourseInstructors: build.query<
      IPaginateResponse<CompanyCourseInstructor>,
      [string, string, IFilters]
    >({
      query: ([id, courseId, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${id}/courses/${courseId}/instructors`,
          params,
        };
      },
      providesTags: (result, _error, [companyId, courseId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyCourseInstructors" as const,
                companyId,
                courseId,
                id,
              })),
              {
                type: "CompanyCourseInstructors",
                companyId,
                courseId,
                id: "LIST",
              },
            ]
          : [],
    }),
    storeCompanyCourseInstructor: build.mutation<
      CompanyCourseInstructor,
      [string, string, CompanyCourseInstructorFormSend]
    >({
      query: ([companyId, courseId, body]) => ({
        url: `/companies/${companyId}/courses/${courseId}/instructors`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCourseInstructors", companyId, courseId, id: "LIST" },
      ],
    }),
    deleteCompanyCourseInstructor: build.mutation<
      CompanyCourseInstructor,
      [string, string, string]
    >({
      query: ([companyId, courseId, instructorId]) => ({
        url: `/companies/${companyId}/courses/${courseId}/instructors/${instructorId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCourseInstructors", companyId, courseId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyCourseInstructorsQuery,
  useDeleteCompanyCourseInstructorMutation,
  useStoreCompanyCourseInstructorMutation,
} = companyCourseInstructorsApi;
